const root = 'AppBar'

export const TestId = {
  logoLink: `${root}-logoLink`,
}
